<template>
  <div>
    <div class="d-flex" style="height: 426px"></div>

    <v-container>
      <div class="mx-auto pb-6" style="max-width: 800px; margin-top: -426px">
        <v-scroll-y-reverse-transition>
          <div>
            <!-- header profile -->
            <div class="d-flex flex-column align-center py-4">
              <div>
                <v-avatar size="80" color="accent">
                  <span class="black--text headline">
                    <span v-if="initialsName">
                      {{ initialsName }}
                    </span>
                    <v-icon v-else>
                      mdi-dots-horizontal
                    </v-icon>
                  </span>
                </v-avatar>
              </div>
              <div class="display-1 text-center">
                <span v-if="userInfo.nome">
                  {{ userInfo.nome }}
                </span>
                <v-icon v-else>
                  mdi-dots-horizontal
                </v-icon>
              </div>
              <div class="subtitle-1">
                <span v-if="userInfo.login">
                  {{ userInfo.login }}
                </span>
                <v-icon v-else>
                  mdi-dots-horizontal
                </v-icon>
              </div>
            </div>

            <!-- tabs profile -->
            <v-card class="mb-4">
              <v-tabs
                v-model="tabs"
                centered
                dense
                background-color="transparent"
              >
                <v-tabs-slider></v-tabs-slider>
                <v-tab>{{ $t("personalDataTitleTabInfo") }}</v-tab>
                <v-tab>{{ $t("personalDataTitleTabSecurity") }}</v-tab>
              </v-tabs>
            </v-card>

            <!-- items tabs profile -->
            <v-tabs-items v-model="tabs" class="transparent">
              <!-- INFO -->
              <v-tab-item>
                <!-- Informações Pessoais -->
                <v-card class="mb-4 pb-4">
                  <v-list-item two-line class="py-4">
                    <v-list-item-content>
                      <v-list-item-title class="pb-2"
                        ><h3>
                          {{ $t("personalDataTitle") }}
                        </h3></v-list-item-title
                      >
                      <v-list-item-subtitle>{{
                        $t("personalDataHint")
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <dialogEditPersonal
                        v-on:refresh-user="getDataUser()"
                        :personal="userInfo"
                      />
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">
                        {{ $t("personalDataFullName") }}
                      </div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userInfo.genero && userInfo.nome">
                          {{ userInfo.genero | gender }}
                          {{ userInfo.nome }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">
                        {{ $t("personalDataDocument") }}
                      </div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userInfo.cpf">
                          {{ userInfo.cpf | cpf }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">
                        {{ $t("personalDataBirthDate") }}
                      </div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userInfo.data_nascimento">
                          {{ userInfo.data_nascimento | momentBirthdate }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>

                <!-- Informações de Contato -->
                <v-card class="mb-4 pb-4">
                  <v-list-item class="py-4">
                    <v-list-item-content>
                      <v-list-item-title class="pb-2"
                        ><h3>
                          {{ $t("contactDataTitle") }}
                        </h3></v-list-item-title
                      >
                      <v-list-item-subtitle>{{
                        $t("contactDataHint")
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <dialogEditContact
                        v-on:refresh-user="getDataUser()"
                        :contact="userInfo"
                      />
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">{{ $t("contactDataPhone") }}</div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userInfo.celular">
                          {{ userInfo.celular }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">{{ $t("contactDataEmail") }}</div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userInfo.email">
                          {{ userInfo.email }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>

                <!-- Informações Financeiras -->
                <v-card class="mb-4 pb-4" v-if="$isCreditOnline()">
                  <v-list-item class="py-4">
                    <v-list-item-content>
                      <v-list-item-title class="pb-2">
                        <h3>
                          {{ $t("financialDataTitle") }}
                        </h3>
                        <!-- Verificação Bancária Status -->
                      </v-list-item-title>
                      <v-list-item-subtitle>{{
                        $t("financialDataHint")
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <dialogEditFinancial
                        v-if="userFetched"
                        :banks="banks"
                        :currentBank="currentBank"
                        v-on:refresh-user="getDataUser()"
                        @resetWatchBankVerification="resetWatchBankVerification"
                        :financial="userInfo"
                      />
                    </v-list-item-action>
                  </v-list-item>

                  <!-- Verification Alert -->
                  <v-list-item
                    v-if="
                      $isCreditOnline() &&
                        notVerified &&
                        checkBank == 1 &&
                        retrieveUserCash > 0
                    "
                  >
                    <v-list-item-content class="py-0">
                      <v-alert
                        :icon="false"
                        dense
                        :type="AlertType"
                        class="mb-0"
                      >
                        <v-row align="center">
                          <v-col class="grow d-flex align-center">
                            <div class="d-flex align-center">
                              <div><v-icon>mdi-alert</v-icon></div>
                              <div class="ml-4" style="line-height:1.4">
                                {{ verificationMsg }}
                                <!-- Btn type icon: processing animation -->
                                <v-btn
                                  v-if="bankVerificationStatus == 2"
                                  small
                                  icon
                                  color="info"
                                  class="ml-2"
                                  :loading="processingLoading"
                                >
                                  <template v-slot:loader>
                                    <span class="custom-loader">
                                      <v-icon>mdi-timer-sand</v-icon>
                                    </span>
                                  </template>
                                </v-btn>
                              </div>
                            </div>
                          </v-col>
                          <v-col
                            v-if="bankVerificationStatus !== '3'"
                            class="d-flex inline align-center justify-end"
                            :class="
                              $vuetify.breakpoint.mobile ? 'pt-0 pr-2' : ''
                            "
                          >
                            <div v-if="bankVerificationStatus == 0" class="">
                              <v-btn
                                color="success"
                                :loading="verifyBtnLoading"
                                @click="verifyBank()"
                              >
                                {{ $t("verifyBank") }}
                              </v-btn>
                            </div>
                            <div>
                              <!-- SAIBA MAIS DIALOG -->
                              <v-dialog
                                v-model="learnMoreDialog"
                                v-if="bankVerificationStatus != 3"
                                max-width="500"
                                :fullscreen="this.$vuetify.breakpoint.xsOnly"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    class="ml-2"
                                    v-show="bankVerificationStatus !== '1'"
                                    :color="btnColor"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <span v-show="bankVerificationStatus">{{
                                      $t("learnMore")
                                    }}</span>
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-toolbar class="text-h5" elevation="0">
                                    <v-btn
                                      icon
                                      class="mr-2"
                                      @click="learnMoreDialog = false"
                                    >
                                      <v-icon>mdi-close</v-icon></v-btn
                                    >
                                    {{ $t("bankVerificationTitle") }}
                                  </v-toolbar>
                                  <v-card-text
                                    class="body-1 text-justify mt-6 px-7"
                                  >
                                    <p>
                                      {{
                                        $t("bankVerificationIntroductionText")
                                      }}
                                    </p>
                                    <h3 class="mb-4">
                                      {{
                                        $t("bankVerificationHowDoesItWorkText")
                                      }}
                                    </h3>
                                    <p>
                                      {{ $t("bankVerificationText") }}
                                    </p>
                                  </v-card-text>
                                </v-card>
                              </v-dialog>
                              <!-- SAIBA MAIS END -->
                            </div>
                            <div v-if="bankVerificationStatus === '1'">
                              <!-- Fechar (X) / Close (X) if Verified status === '1' -->
                              <v-btn icon @click="notVerified = false">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </v-alert>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- Verification Alert END -->
                  <div v-if="verifyBankEnabled">
                    <v-list-item>
                      <v-list-item-content>
                        <div class="overline d-flex align-center">
                          Banco
                          <v-icon
                            v-if="
                              checkBank === '1' &&
                                bankVerificationStatus === '1'
                            "
                            small
                            class="ml-1"
                            color="blue"
                            >mdi-check-decagram</v-icon
                          >
                        </div>
                        <v-list-item-title class="pl-2 pt-2">
                          <span v-if="currentBank">
                            {{ currentBank.text }}
                          </span>
                          <div v-else class="grey--text">
                            <i>{{ $t("notRegistered") }}</i>
                          </div>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                  <v-divider class="ml-4"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <!-- OBS.: Por enquanto PIX não está sendo traduzido ou substituído -->
                      <div class="overline d-flex align-center">
                        Tipo Chave PIX
                      </div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userInfo.tipo_chave">
                          {{ userInfo.tipo_chave | typePix }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">Chave Pix</div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userInfo.chave_pix">
                          {{ userInfo.chave_pix }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>

                <!-- Dialog Edit Limits (Deposito, Saques, Tempo de uso) -->
                <v-card class="mb-4 pb-4">
                  <v-list-item class="py-4">
                    <v-list-item-content>
                      <v-list-item-title class="pb-2">
                        <h3>
                          {{ $t("userLimits") }}
                        </h3>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ $t("userLimitsSubtitle") }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <dialogEditLimits
                        v-on:refresh-user="getDataUser()"
                        :userLimits="userInfo"
                      />
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">
                        {{ $t("betMaximum") }}
                      </div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userFetched">
                          {{ limitsBet(userInfo.aposta_maxima) }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">
                        {{ $t("activiteMinutes") }}
                      </div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userFetched">
                          {{
                            limitsMinutesActivityInterval(
                              userInfo.minutos_atividade
                            )
                          }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4"></v-divider>
                  <v-list-item v-if="$isCreditOnline()">
                    <v-list-item-content>
                      <div class="overline">{{ $t("maximumDeposit") }}</div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userFetched">
                          {{ limitsMaxDeposit(userInfo.deposito_maximo) }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4" v-if="$isCreditOnline()"></v-divider>
                  <v-list-item v-if="$isCreditOnline()">
                    <v-list-item-content>
                      <div class="overline">{{ $t("depositInterval") }}</div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userFetched">
                          {{
                            limitsDepositInterval(userInfo.deposito_intervalo)
                          }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4" v-if="$isCreditOnline()"></v-divider>
                  <v-list-item v-if="$isCreditOnline()">
                    <v-list-item-content>
                      <div class="overline">{{ $t("depositLimitValue") }}</div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userFetched">
                          {{ limitsValue(userInfo.deposito_limite_valor) }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4" v-if="$isCreditOnline()"></v-divider>
                </v-card>

                <!-- Informações de Endereço -->
                <v-card class="mb-4 pb-4">
                  <v-list-item class="py-4">
                    <v-list-item-content>
                      <v-list-item-title class="pb-2">
                        <h3>
                          {{ $t("addressDataTitle") }}
                        </h3>
                      </v-list-item-title>
                      <v-list-item-subtitle>{{
                        $t("addressDataHint")
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <dialogEditAddress
                        v-on:refresh-user="getDataUser()"
                        :address="userInfo"
                      />
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">
                        {{ $t("addressDataPostal") }}
                      </div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userInfo.cep">
                          {{ userInfo.cep }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">
                        {{ $t("addressDataAddress") }}
                      </div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userInfo.endereco">
                          {{ userInfo.endereco }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">
                        {{ $t("addressDataNumber") }}
                      </div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userInfo.numero">
                          {{ userInfo.numero }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">
                        {{ $t("addressDataDistrict") }}
                      </div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userInfo.bairro">
                          {{ userInfo.bairro }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">
                        {{ $t("addressDataComplement") }}
                      </div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userInfo.complemento">
                          {{ userInfo.complemento }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">
                        {{ $t("addressDataCityStateTitle") }}
                      </div>
                      <v-list-item-title class="pl-2 pt-2">
                        <span v-if="userInfo.cidade || userInfo.estado">
                          {{ userInfo.cidade }} - {{ userInfo.estado }}
                        </span>
                        <v-icon v-else>
                          mdi-dots-horizontal
                        </v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-tab-item>

              <!-- SEGURANÇA -->
              <v-tab-item>
                <!-- Dados de acesso -->
                <v-card class="mb-4 pb-4">
                  <v-list-item
                    class="py-4"
                    :class="{
                      'd-flex flex-column': $vuetify.breakpoint.smAndDown
                    }"
                  >
                    <v-list-item-content
                    :class="{ 'align-start': $vuetify.breakpoint.smAndDown }"
                    :style="$vuetify.breakpoint.smAndDown ? 'width: 100%;' : ''"
                  >
                      <v-list-item-title class="pb-2">
                        <h3>{{ $t("credentialDataTitle") }}</h3>
                      </v-list-item-title>
                      <v-list-item-subtitle style="white-space: normal;">
                        {{ $t("credentialDataHint") }}
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action
                      class="ml-0"
                      :class="{ 'mb-n14': $vuetify.breakpoint.smAndDown }"
                      :style="$vuetify.breakpoint.smAndDown ? 'width: 100%;' : ''"
                    >
                      <dialogEditCredential
                        v-on:refresh-user="getDataUser"
                        :credential="userInfo"
                      />
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">
                        {{ $t("credentialDataLogin") }}
                      </div>
                      <v-list-item-title class="pl-2 pt-2">{{
                        userInfo.login
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="ml-4"></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <div class="overline">
                        {{ $t("credentialDataPassword") }}
                      </div>
                      <v-list-item-title class="pl-2 pt-2">
                        ••••••••
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>

                <!-- Autenticação de duas etapas -->
                <v-card
                  v-if="$store.state.operators.multifactor == 1"
                  class="mb-4 pb-4"
                >
                  <v-list-item class="py-4">
                    <v-list-item-content>
                      <v-list-item-title class="pb-2">
                        <h3>{{ $t("twoStepsAuthTitle") }}</h3>
                      </v-list-item-title>

                      <v-list-item-subtitle style="white-space: normal;">
                        {{ $t("twoStepsAuthHint") }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="d-flex flex-column align-start">
                      <v-alert
                        :class="{
                          'px-16': !$vuetify.breakpoint.xsOnly
                            && twoStepsAlertConfig.type === 'success'
                        }"
                        :type="twoStepsAlertConfig.type"
                        border="left"
                        :icon="false"
                        text
                      >
                        {{ twoStepsAlertConfig.msg }}
                      </v-alert>

                      <v-switch
                        v-model="userInfo.multifactor"
                        class="ml-3"
                        :label="$t('twoStepsAuthTitle')"
                        :disabled="twoStepsAlertConfig.type === 'info'"
                        :readonly="twoStepsAlertConfig.type === 'success'"
                        hide-details
                        @click="
                          twoStepsAlertConfig.type === 'success'
                          && openDialogVerifySmsToken('twoStepsAuthentication')
                        "
                      ></v-switch>

                      <div v-if="twoStepsAlertConfig.type === 'info'">
                        <v-btn
                          class="ml-3 mt-4 px-9"
                          color="primary"
                          large
                          style="text-transform: none; max-width: 300px;"
                          @click="openDialogVerifySmsToken('phoneVerification', true)"
                        >
                          {{ $t("twoStepsAuthBtnVerifyPhone") }}
                        </v-btn>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-scroll-y-reverse-transition>
      </div>
    </v-container>
  </div>
</template>

<script>
import dialogEditPersonal from "../settings/dialogEditPersonal";
import dialogEditContact from "../settings/dialogEditContact";
import dialogEditAddress from "../settings/dialogEditAddress";
import dialogEditCredential from "../settings/dialogEditCredential";
import dialogEditFinancial from "../settings/dialogEditFinancial";
import dialogEditLimits from "../settings/dialogEditLimits";
export default {
  name: "profile",
  components: {
    dialogEditPersonal,
    dialogEditContact,
    dialogEditAddress,
    dialogEditCredential,
    dialogEditFinancial,
    dialogEditLimits,
  },
  data: () => ({
    open: true,
    userInfo: {},
    firstName: "",
    initialsName: "",
    // avatarColor: 'grey',
    // colors:[
    //     'teal','blue','orange','red','purple','black',
    //     'indigo', 'deep-purple', 'light-blue', 'cyan', 'green',
    //     'light-green', 'lime', 'amber','deep-orange', 'brown',
    //     'blue-grey', 'grey'
    // ],
    tabs: null,
    userFetched: false,
    checkBank: "",
    bankVerifyIcon: "",
    bankVerifyIconColor: "",
    AlertType: "",
    verificationMsg: "",
    bankVerificationStatus: "",
    verifyBtnLoading: false,
    notVerified: false,
    banks: [],
    currentBank: null,
    learnMoreDialog: false,
    // processing animation
    loader: null,
    processingLoading: true,
  }),
  mounted() {
    if (this.verifyBankEnabled) {
      this.operatorCheckBank();
      this.getBankVerificationPlayer();
      this.checkVerificationStatusTimer();
    }

    this.getDataUser();

    // Fluxo de acessa Aba Segurança via Btn Autenticação de duas etapas via
    // Dialog de boas vindas pós cadastro
    if (this.$route.query.tabProfile === "security") {
      this.tabs = 1;
      this.$handleURLState("tabProfile", "delete");
    }
  },
  destroyed() {
    clearInterval(this.checkVerificationIntervalID);
  },
  computed: {
    // Recupera o saldo do User para
    // usar na experiência do Alert
    retrieveUserCash() {
      return this.$store.state.cash;
    },
    verifyBankEnabled() {
      return (
        this.$isCreditOnline() && this.$store.state.operators.verify_bank == "1"
      );
    },
    twoStepsAlertConfig() {
      return {
        type: Number(this.userInfo.confirmed_phone) ? "success" : "info",
        msg: this.$tc(
          "twoStepsAuthAlertVerifyPhone",
          Number(this.userInfo.confirmed_phone)
        ),
      }
    },
    showDialogVerifySmsTokenStore() {
      const dialogState = this.$store.getters.getDialogVerifySmsToken;

      return dialogState;
    },
  },
  watch: {
    "userInfo.nome": function(val) {
      this.initials(val);
      this.$store.commit("subTitlePages", val);
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    showDialogVerifySmsTokenStore(dialogState) {
      if (
        dialogState.trigger === "phoneVerification"
        || dialogState.trigger === "twoStepsAuthentication"
      ) this.getDataUser();
    },
  },
  methods: {
    // Get Data User
    getDataUser() {
      this.$Progress.start();
      this.$axios
        .get("player/profile/getPlayer")
        .then((response) => {
          this.userFetched = true;

          // se data de nascimento vim vazia (para corrigir bug no plugin de data):
          const Birthdate = response.data.dados.data_nascimento;
          if (Birthdate == "0000-00-00") {
            const target = response.data.dados;
            const source = {
              data_nascimento: new Date().toISOString().substr(0, 10),
            }; // coloco o dia de hoje
            const returnedTarget = Object.assign(target, source); // substituo no json
            this.userInfo = returnedTarget;
          } else {
            this.userInfo = response.data.dados;
          }

          this.userInfo.block_pix = response.data.block_pix == "1";

          if (this.userInfo.tipo_chave == null) {
            this.userInfo.block_pix = false;
          }

          this.userInfo.multifactor = Number(this.userInfo.multifactor);

          this.userInfo.operatorBlockPix = response.data.block_pix == "1";

          if (this.verifyBankEnabled) {
            this.$axios
              .get("/player/online/bank/listBanksOperator")
              .then((res) => {
                this.banks = res.data.dados.map((bank) => ({
                  text: `${bank.cod_bank} - ${bank.nome_curto}`,
                  value: bank.cod_bank,
                }));

                const bank = this.banks.find(
                  (bank) => bank.value == response.data.dados.codigo_banco
                );
                this.currentBank = bank;
              });
          }
        })
        .catch(() => {
          const msg = "Algo deu errado. Tente novamente.";
          const color = "warning";
          this.$store.commit("setNotification", {
            msg,
            color,
          });
          this.$Progress.fail();
        })
        .finally(() => {
          setTimeout(() => (this.open = false), 500);
          this.$Progress.finish();
        });
    },
    // // radom color background to avatar
    // randomColorAvatar(){
    //     this.avatarColor = this.colors[Math.floor(Math.random() * this.colors.length)];
    // },
    // Return firstName and Iniciais do Nome
    initials(name) {
      var names = name.split(" ");
      this.firstName = names[0];
      this.initialsName = names[0].substring(0, 1).toUpperCase();
      if (names.length > 1) {
        this.initialsName += names[names.length - 1]
          .substring(0, 1)
          .toUpperCase();
      }
    },
    limitsValue: function(value) {
      if (value == "0.00" || value == "0" || value == null) {
        return this.$t("noLimits");
      } else {
        return value;
      }
    },
    limitsBet: function(value) {
      if (value == "0.00" || value == "0" || value == null) {
        return this.$t("noLimits");
      } else {
        return value;
      }
    },
    limitsMaxDeposit: function(value) {
      if (value == null) {
        return this.$t("noLimits");
      } else {
        return value;
      }
    },
    limitsDepositInterval: function(value) {
      const obj = {
        24: this.$t("twentyFourHours"),
        48: this.$t("fortyEightHours"),
        168: this.$t("sevenDays"),
        720: this.$t("thirtyDays"),
        0: this.$t("noLimits"),
      };
      if (value == "0.00" || value == "0" || value == null) {
        return this.$t("noLimits");
      } else {
        return obj[value];
      }
    },
    limitsMinutesActivityInterval: function(value) {
      const obj = {
        30: this.$t("twentyMinutes"),
        60: this.$t("sixtyMinutes"),
        90: this.$t("ninetyMinutes"),
        120: this.$t("oneHundredTwentyMinutes"),
        0: this.$t("noLimits"),
      };
      if (value == "0.00" || value == "0" || value == null) {
        return this.$t("noLimits");
      } else {
        return obj[value];
      }
    },
    // Verificação bancária
    getBankVerificationPlayer() {
      this.$axios
        .get("/player/online/bank/playerVerificationBank")
        .then((response) => {
          if (response.status === 200) {
            let resp = response.data.dados;
            this.bankVerificationStatus = resp.verificacao_bancaria;

            if (this.bankVerificationStatus == "2") {
              clearInterval(this.checkVerificationIntervalID);
              this.checkVerificationStatusTimer();
            } else {
              clearInterval(this.checkVerificationIntervalID);
            }

            this.handleVerificationStatus();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // Tratando o Alert de acordo com o status
    handleVerificationStatus() {
      // Verified
      if (this.bankVerificationStatus === "1") {
        if (localStorage.getItem("bank_verified") !== "true") {
          this.notVerified = true;
          this.AlertType = "success";
          this.btnColor = "info";
          this.verificationMsg = this.$t("successVerification");
          localStorage.setItem("bank_verified", "true");
        }
      }
      // Pending
      if (this.bankVerificationStatus === "0") {
        this.notVerified = true;
        this.AlertType = "warning";
        this.btnColor = "info";
        this.verificationMsg = this.$t("bankVerificationPending");
        localStorage.setItem("bank_verified", "false");
      }
      // Processing
      if (this.bankVerificationStatus === "2") {
        this.notVerified = true;
        this.AlertType = "info";
        this.btnColor = "blue accent-4";
        this.verificationMsg = this.$t("bankVerificationProcessing");
        localStorage.setItem("bank_verified", "false");
      }
      // Denied
      if (this.bankVerificationStatus === "3") {
        this.notVerified = true;
        this.AlertType = "error";
        this.btnColor = "info";
        this.verificationMsg = this.$t("profileBankVerificationDenied");
        localStorage.setItem("bank_verified", "false");
      }
    },
    verifyBank() {
      this.verifyBtnLoading = true;
      this.verifyBtnDisable = true;

      this.$axios
        .post("/player/online/bank/validateBank")
        .then((response) => {
          if (response.status === 200) {
            const msg = response.data.messages;
            const color = "success";
            this.$store.commit("setNotification", { msg, color });
            this.getBankVerificationPlayer();
            this.verifyBtnLoading = false;
            this.verifyBtnDisable = true;
          }
        })
        .catch((error) => {
          this.verifyBtnLoading = false;
          this.verifyBtnDisable = false;
          const msg = error.response.data.messages.error;
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        });
    },
    // check if Operator make verification
    operatorCheckBank() {
      this.$axios
        .get("/player/online/bank/operatorCheckBank")
        .then((response) => {
          let resp = response.data.dados;
          this.checkBank = resp.check_bank;
        });
    },
    // Watch status
    checkVerificationStatusTimer() {
      this.checkVerificationIntervalID = setInterval(() => {
        this.getBankVerificationPlayer();
      }, 5000);
    },
    resetWatchBankVerification() {
      this.bankVerificationStatus = "0";
      this.handleVerificationStatus();
      clearInterval(this.checkVerificationIntervalID);
      this.checkVerificationStatusTimer();
    },
    openDialogVerifySmsToken(typeVerification, bothVerification) {
      this.$store.commit("setDialogVerifySmsToken", {
        status: true,
        typeVerification,
        bothVerification,
        removeTwoStepsAuth: typeVerification == "twoStepsAuthentication"
          && this.userInfo.multifactor == 1
      });
    },
  },

  filters: {
    // Format Birthdate
    momentBirthdate: function(date) {
      const day = new Date().toISOString().substr(0, 10);
      if (date === day) {
        return "Não cadastrada.";
      } else {
        //
        // FIX BUG:
        // NÃO FUNCIONA "this.$" reativos em "filter"!
        // return this.$date.format(date, 'DD-MM-YYYY');
        //
        const day = new Date(`${date}T00:00:00`).toLocaleDateString();
        return day;
      }
    },
    // Format Gender
    gender: function(value) {
      if (value === "1") return "Sr.";
      if (value === "2") return "Sra.";
    },
    // Format CPF
    cpf: function(value) {
      if (value == null || value == "") {
        return "Não cadastrado.";
      } else {
        var cpf = value;
        var format = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        return format;
      }
    },
    typePix: function(value) {
      const obj = {
        CPF: "CPF",
        EMAIL: "E-mail",
        PHONE: "Telefone",
        EVP: "Chave Aleatória",
      };
      return obj[value];
    },
  },
};
</script>

<style>
/* Processing animation  */

.custom-loader {
  background: "mdi-timer-sand", "mdi-timer-sand-paused",
    "mdi-timer-sand-complete";
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
